import { Pipe } from '@angular/core';
import { COLORS } from '../constants/app.constant';

@Pipe({
  name: 'randomColor',
})
export class RandomColorPipe {
  transform(value: string): string {
    let hash = 0;
    for (let i = 0; i < value.length; i++) {
      hash = value.charCodeAt(i) + ((hash << 5) - hash);
    }
    const index = Math.abs(hash) % COLORS.length;
    return COLORS[index];
  }
}
